module.exports = __webpack_public_path__ + "img/avatar-gray.2bb70151.svg";